import type { SwiftIdEnum } from './swift-id-enum.model';

export interface GenerateSwiftIdEnumOptions {
  readonly type?: string;
  readonly occupationType?: string;
}

/**
 * Generates SwiftID enum objects based on the provided options
 */
export function generateSwiftIdEnumObjects({
  type,
  occupationType,
}: GenerateSwiftIdEnumOptions = {}): readonly SwiftIdEnum[] {
  // Individual Application
  if (type === 'occupations') {
    return [
      { id: 'OccupationTypeBusinessOwners' },
      { id: 'OccupationTypeOther' },
    ];
  }

  if (type === 'occupation-categories') {
    if (occupationType === 'OccupationTypeBusinessOwners') {
      return [{ id: 'Cafe And Restaurant' }, { id: 'Others' }];
    }
    if (occupationType === 'OccupationTypeOther') {
      return [{ id: 'Others' }];
    }
  }

  if (type === 'sources-of-wealth') {
    return [{ id: 'Others' }];
  }

  // Company Application
  if (type === 'industries') {
    return [{ id: 'Technology' }, { id: 'Others' }];
  }

  if (type === 'natures-of-business') {
    return [{ id: 'Technology' }, { id: 'Others' }];
  }

  if (type === 'sources-of-funds') {
    return [{ id: 'Others' }];
  }

  return [];
}

/**
 * Generates a single SwiftID enum object
 */
export function generateSwiftIdEnumObject(id: string): SwiftIdEnum {
  return { id };
}
